import { calculatePrice } from './helpers';
import type { UpdateTeamDataType } from '~/lib/stores/team';
import type { SubscriptionInterval } from '~/types/subscription';

interface PlanRowProps {
  title: string;
  rateMonthly: number;
  seats: number;
  subscriptionInterval: SubscriptionInterval;
}

export const PlanRow = ({ title, rateMonthly, seats, subscriptionInterval }: PlanRowProps) => {
  const calculatedPrice = calculatePrice({
    seats,
    planPrice: rateMonthly,
    isYearly: subscriptionInterval === 'yearly',
  });

  return (
    <div className="flex justify-between gap-2 items-center">
      <div className="flex flex-col gap-1">
        <div className="text-sm font-semibold text-bolt-ds-textPrimary">{title}</div>
        <div className="text-sm text-bolt-ds-textTertiary">
          ${rateMonthly.toFixed(2)} x {seats} seats {subscriptionInterval === 'yearly' ? 'x 12 months' : '/ month'}
        </div>
      </div>
      <div className="w-1/2 text-right text-bolt-ds-textPrimary text-lg">${calculatedPrice}</div>
    </div>
  );
};

export const TotalPlanRow = ({
  updateType,
  totalPrice,
}: {
  updateType: UpdateTeamDataType;
  totalPrice: string | null;
}) => {
  return (
    <>
      <div className="h-px w-full bg-bolt-ds-borderDivider mb-2" />

      <div className="flex justify-between gap-2 items-center">
        <div className="flex flex-col gap-1">
          <div className="text-sm font-semibold text-bolt-ds-textPrimary">Total</div>
          <div className="text-sm text-bolt-ds-textTertiary">
            {updateType === 'upgrade'
              ? 'Payable now'
              : ['downgrade', 'remove'].includes(updateType)
                ? 'This change will be reflected on your next invoice'
                : ''}
          </div>
        </div>
        <div className="w-1/2 text-right text-bolt-ds-textPrimary text-lg">
          {totalPrice !== null ? (updateType === 'upgrade' ? '+' : '-') + `$${totalPrice}` : 'Free'}
        </div>
      </div>
    </>
  );
};
